import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { AuthChangePasswordStateData } from './types';

const initialState: AuthChangePasswordStateData = {
	data: { data: { error: '', success: '' }, error: null },
	loading: false,
	error: '',
};

export const fetchChangePassword = createAsyncThunk(
	'api/fetchChangePassword',
	({ token, psw1, psw2 }: { token: string; psw1: string; psw2: string }) => api.fetchChangePassword(token, psw1, psw2),
);

const changePasswordSlice = createSlice({
	name: 'recover',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchChangePassword.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchChangePassword.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchChangePassword.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			});
	},
});

export default changePasswordSlice.reducer;
